import { render, staticRenderFns } from "./EmployeeDataTraining.vue?vue&type=template&id=f1fa43f0&"
import script from "./EmployeeDataTraining.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports